/** Быстрый фильтр "Мои": 1 — мои в работе, 2 — мои завершённые */
export const MY_PAID_SERVICE_STATUS_OPTIONS = [
  { id: 1, label: 'В работе' },
  { id: 2, label: 'Завершены' }
]

/** Селект "Непрочитанные" стандартного фильтра (myInWorkUnread) */
export const MY_IN_WORK_UNREAD_OPTIONS = [
  { id: 1, label: 'Да', value: 1 },
  { id: 2, label: 'Нет', value: 0 }
]
